<template>
  <r-panel :disabled="disabled" :title="title" :button_add="true" @click_add="click_add">
    <r-level-track-level-table ref="table" :items.sync="values" :toolbar="false"/>
  </r-panel>
</template>

<script>


import VueTypes from "vue-types";

import RLevelTrackLevelTable from "@/modules/redactor/views/level-track/level/r-level-track-level-table.vue";
import RPanel from "@/modules/redactor/views/utils/r-panel.vue";

import { LevelTrackLevel } from "@/modules/redactor/models/level-track/LevelTrackLevel";

export default {
  name: "r-level-track-level-panel",
  components: {RPanel, RLevelTrackLevelTable},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Levels"),
    items: VueTypes.arrayOf(LevelTrackLevel),
  },
  computed: {
    values() {
      if (this.items) {
        return this.items;
      } else {
        let values = [];
        this.$emit("update:items", values);
        return values;
      }
    }
  },
  methods: {
    click_add() {
      this.$refs["table"].row_create();
    }
  }
}

</script>
